import { fetchDefectReportPictureV1ControllerGetListByRings } from 'generated/apiComponents';
import { defectReportPictureSyncService } from 'technical/db/sync/defect-report-picture-sync.service';

const PAGE_SIZE = 5;

export const syncDefectReportPictureData = async (
  constructionSiteId: string,
  ringNumberStart: number,
  ringNumberEnd: number,
  headers: any,
) => {
  let page = 0;
  let hasMore = true;

  while (hasMore) {
    const response = await fetchDefectReportPictureV1ControllerGetListByRings({
      pathParams: { constructionSiteId },
      queryParams: {
        ringNumberStart,
        ringNumberEnd,
        paginationPage: page,
        paginationSize: PAGE_SIZE,
      },
      headers,
    });

    const pictures = response?.pictures ?? [];
    if (pictures.length > 0) {
      await defectReportPictureSyncService.download(pictures);
    }

    if (pictures.length < PAGE_SIZE) {
      hasMore = false;
    } else {
      page++;
    }
  }
};
